import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Pet policy banner',
    },
  },
};


export function PetPolicyHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="petpolicyhero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Pet policy banner"
    >
      <InnerPageHeroSubtitle path="petpolicyhero.subtitle" />
      <RichTextContent
        path="petpolicyhero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken path="petpolicyhero.subtitle" type="richtext" as="span" className="hidden" style={{ display: 'none' }}>
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="petpolicyhero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'PetPolicyHero',
  displayName: 'Pet Policy Hero',
  tokens: {
    'petpolicyhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Pet Policy</p>',
    },
    'petpolicyhero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue: '<p>Pet-Friendly Living in <span data-type="field-token" data-field="property_address_city"></span>, <span data-type="field-token" data-field="property_address_state"></span></p>',
    },
  },
  slotGroups: {
    'petpolicyhero.bg_image': bgImageDef,
  },
};

(PetPolicyHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default PetPolicyHero;
